import { emptyApi } from '@/app/store/api/emptyApi';
import {
  ClientEventsControllerRecordApiArg,
  ClientEventsControllerRecordApiResponse,
  ClientWildberriesIntegrationControllerExistsApiArg,
  ClientWildberriesIntegrationControllerExistsApiResponse,
  ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiArg,
  ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiResponse,
} from '@/app/store/api/restApi';

export const analiticsApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    sendEvents: build.mutation<
      ClientEventsControllerRecordApiResponse,
      ClientEventsControllerRecordApiArg
    >({
      query: ({ recordEventsRequestDto }) => ({
        url: 'events',
        method: 'POST',
        body: recordEventsRequestDto,
      }),
    }),
    getWildberriesSellerInfo: build.query<
      ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiResponse,
      ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiArg
    >({
      query: () => ({ url: `integrations/wildberries-seller-analytics` }),
    }),
    getWildberriesIntegrationExists: build.query<
      ClientWildberriesIntegrationControllerExistsApiResponse,
      ClientWildberriesIntegrationControllerExistsApiArg
    >({
      query: () => ({ url: `integrations/wildberries/exists` }),
    }),
  }),
});

export const { useSendEventsMutation, useGetWildberriesSellerInfoQuery, useGetWildberriesIntegrationExistsQuery } =
  analiticsApi;
